import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field } from 'redux-form';

import DatepickerField from 'components/fields/DatepickerField';
import AutosuggestField from 'components/fields/AutosuggestField';
import Link from 'components/common/Link';
import IconButton from 'components/common/IconButton';
import IconPlus from 'components/icons/IconPlus';
import IconCross from 'components/icons/IconCross';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import dateFormat from 'config/dateFormat';
import insuranceSpecialDateTypes from 'config/insuranceSpecialDateTypes';

const styles = theme => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
  fieldArrayLabel: {
    marginTop: 20,
    position: 'relative',
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  fieldContainder: {
    marginTop: 10,
    position: 'relative',
    padding: 16,
    border: `1px dashed ${theme.palette.grey[600]}`,
    borderRadius: 4,
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 24,
      height: 25,
      backgroundColor: theme.palette.common.white,
      top: -4,
      right: -12,
      zIndex: 1,
    },
  },
  fieldIndex: {
    top: -4,
    left: -12,
    position: 'absolute',
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    padding: '4px 0',
    width: 24,
    textAlign: 'center',
    fontWeight: 700,
    color: theme.palette.primary[500],
    backgroundColor: theme.palette.common.white,
    transform: 'none',
  },
  iconPlus: {
    width: 14,
    height: 14,
    marginTop: -2,
    marginRight: 8,
  },
  buttonAddDay: {
    margin: '16px 0 0 0',
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  buttonDelete: {
    position: 'absolute',
    right: -24,
    top: -16,
    zIndex: 10,
  },
});

const InsuranceCreateEditFormSpecialDateFieldArray = ({
  fields,
  classes,
}) => (
  <Fragment>
    {fields.length > 0 && (
      <Typography className={classes.fieldArrayLabel}>
        Special Dates
      </Typography>
    )}
    {fields.map((field, index) => (
      <div className={classes.fieldContainder} key={field}>
        <Typography className={classes.fieldIndex}>
          {index + 1}
        </Typography>
        <IconButton
          className={classes.buttonDelete}
          onClick={() => {
            fields.remove(index);
          }}
          tooltipContent="Delete Contact"
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
        <Grid
          container
          spacing={24}
          alignItems="flex-end"
          justify="space-between"
        >
          <Grid item xs={7}>
            <Field
              id={`${field}.Type Of Date`}
              name={`${field}.Type Of Date`}
              placeholder="Date Type"
              component={AutosuggestField}
              fullWidth
              listWidth="auto-right"
              renderSuggestionContent={suggestion => suggestion}
              onSuggestionSelected={suggestion => suggestion}
              fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
                if (offset === 0) {
                  if (value.length > 0) {
                    resolve(insuranceSpecialDateTypes
                      .filter(item => item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
                  } else {
                    resolve(insuranceSpecialDateTypes);
                  }
                } else {
                  resolve([]);
                }
              }))}
            />
          </Grid>
          <Grid item xs={5}>
            <Field
              id={`${field}.Special Date`}
              name={`${field}.Special Date`}
              component={DatepickerField}
              normalize={normalize.date}
              fullWidth
              minDate="01/01/1900"
              maxDate="01/01/2100"
              dateFormat={dateFormat}
              placeholder="mm/dd/yyyy"
              errorPlacement="top"
              maxLength="10"
              endIcon="start"
              horizontalPlacement="right"
            />
          </Grid>       
        </Grid>
      </div>
    ))}
    <Link
      className={classes.buttonAddDay}
      color="primary"
      size="md"
      bold
      onClick={() => {
        fields.push({});
      }}
    >
      <IconPlus className={classes.iconPlus} />
      Add Condition Date
    </Link>
  </Fragment>
);

InsuranceCreateEditFormSpecialDateFieldArray.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(InsuranceCreateEditFormSpecialDateFieldArray);



// WEBPACK FOOTER //
// ./src/components/patient/InsuranceCreateEditDialog/InsuranceCreateEditFormSpecialDateFieldArray.js